import classNames from 'classnames';
import { type KeyboardEvent, type MouseEvent, useCallback, useEffect, useRef } from 'react';
import { IconButton } from '../../../components/IconButton';
import { Keys } from '../../../components/Popup/Popup';
import useIsMounted from '../../../hooks/useIsMounted';
import styles from './Search.module.css';
export type SearchProps = {
  className?: string;
  onShowSearch?: () => void;
  onHideSearch?: () => void;
  open: boolean;
  text: {
    url?: string;
    label?: string;
    placeholder?: string;
  };
};
function Search({
  text: {
    url,
    label,
    placeholder
  },
  onShowSearch,
  onHideSearch,
  open,
  className
}: SearchProps) {
  const formRef = useRef<HTMLFormElement | null>(null);
  const inputRef = useRef<HTMLInputElement | null>(null);
  const mounted = useIsMounted();
  useEffect(() => {
    if (!open || !inputRef.current) return;
    inputRef.current.focus();
  }, [open]);
  const handleResetKeyPressed = useCallback((event: KeyboardEvent<HTMLButtonElement>) => {
    if (event.key === Keys.Enter || event.key === Keys.Space || event.key === Keys.Space) return onHideSearch?.();
  }, [onHideSearch]);
  const handleClickReset = useCallback(() => {
    onHideSearch?.();
  }, [onHideSearch]);
  const handleInputKeyPressed = useCallback((event_0: KeyboardEvent<HTMLInputElement>) => {
    if (event_0.key !== Keys.Escape) return;
    onHideSearch?.();
  }, [onHideSearch]);
  const handleClickSearch = useCallback((event_1: MouseEvent<HTMLButtonElement>) => {
    if (!mounted) return;
    if (!open) {
      onShowSearch?.();
      event_1.preventDefault();
    }
    if (!inputRef.current?.value) {
      event_1.preventDefault();
    }
  }, [mounted, onShowSearch, open]);
  return <form action={url} method="POST" ref={formRef} className={classNames(styles.form, className)}>
      <div className={classNames(styles.inputContainer, {
      [styles.open!]: open
    })}>
        <input onKeyUp={handleInputKeyPressed} name="query" placeholder={placeholder} aria-label={placeholder} ref={inputRef} id="header-search-input" className={styles.input} tabIndex={open ? 0 : -1} />
        <IconButton type="reset" iconName="x" onClick={handleClickReset} onKeyUp={handleResetKeyPressed} className={styles.resetButton} tabIndex={open ? 0 : -1} kind="plain" aria-label="Reset"></IconButton>
      </div>
      <IconButton size="large" type="submit" iconName="search" disabled_={!mounted} onClick={handleClickSearch} className={styles.searchButton} title={label}>
        <span className="sr-only">{label}</span>
      </IconButton>
    </form>;
}
export default Search;